export default "__VITE_ASSET__DfrEJ7Rg__"